import helper from '../data/Helper';

const emailRegex = new RegExp(/\S+@\S+\.\S+/);
const phoneRegex = new RegExp(/^[0-9 ()+-]+$/);
const ccardRegex = new RegExp(/^[0-9-]+$/);
const cvcRegex = new RegExp(/^[0-9]+$/);
const notAllowSpcl = new RegExp(/^[A-Za-z0-9]+$/);
const notAllowSpclname = new RegExp(/^[a-zA-Z ]*$/);//april 2024// 
const allowOnlyChars = new RegExp(/^[a-zA-Z ]+$/);


export const termsValidator = (value) => value ? "" : "Please accept terms & conditions of the application to proceed";

//Personal info
export const nameValidator = (value) => {
    if (!value) {
        return "Please Enter Full Name as in your NRIC/Passport"
    } else if (!notAllowSpclname.test(value)) {
        return "Please Enter Full Name as in your NRIC/Passport"
    } else if (value.length > 80) {
        return "Please Enter Full Name as in your NRIC/Passport"
    }
}
export const nricValidator = (value) => {
    if (!value) {
        return "Please Enter your NRIC/Passport Number"
    }
    else if (value.length > 20) {
        return "Please Enter your NRIC/Passport Number"
    } else if (!notAllowSpcl.test(value)) {
        return "Please Enter your NRIC/Passport Number"
    }
}

export const countryValidator = (value) => value ? "" : "Please Select a Valid Country from the list";
export const IDTypeValidator = (value) => value ? "" : "Please Select a Valid ID Type from the list";

export const emailValidator = (value) => {
    if (!value) {
        return "Please Enter a Valid Email Address"
    } else if (!emailRegex.test(value)) { //// if (value) {
        return "Please Enter a Valid Email Address"
    } else if (value.length > 50) {
        return "Please Enter a Valid Email Address"
    }
    //}
}


//Fund transfer
export const TransferFromValidator = (value) => value ? "" : "Please select a card / account for the transfer.";

export const crditAbleValidator = (value) => {

    if (!value) {
        return "Please enter a valid CreditAble account number"
    }
    if (value) {
        if (!ccardRegex.test(value)) {
            return "Please enter a valid Creditable account number"
        }
        else if (value.substring(0, 5).trim() !== "04137" && value.substring(0, 5).trim() !== '04138') {
            return "Please enter a valid CreditAble account number."
        }
        else if (value.length !== 11) {
            return "Please enter a valid CreditAble account number"
        }

    }
}

export const priceValidator = (value) => value ? "" : "Please select your preferred loan plan";
export const TransferToValidator = (value) => value ? "" : "Please nominate a bank to receive the Fund Transfer.";
export const acntNameValidatorold = (value) => {
    if (!value) {
        return "Please enter name of the account holder of nominated bank.";
    }
    else if (value.length > 80) {
        return "Please enter name of the account holder of nominated bank.";
    }
    else if (!allowOnlyChars.test(value)) {
        return "Numeric Account Holder Name not acceptable."
    } else if (value) {

        //APR 2024 new validation rules 

        let fullNameInID = localStorage.getItem('CFN');
        fullNameInID = fullNameInID.toUpperCase();


        let nameOfAcntHolderVal = value;
        nameOfAcntHolderVal = nameOfAcntHolderVal.toUpperCase();
        let nameOfAcntHolder = nameOfAcntHolderVal.split(" ");

        const itemsArray = fullNameInID.split(" "); //logic 3 to separate all string value to array items
        ////console.log("itemsArray----->" + itemsArray);
        const updatedItems = itemsArray.map(item => item.charAt(0)); //logic #002 to get first char
        ////console.log(updatedItems);

        const toremoveSpaceArry = fullNameInID.replace(/\s/g, '') //logic #001 to merge text
        ////console.log("toremoveSpaceArry---->" + toremoveSpaceArry);

        ////console.log(toremoveSpaceArry);



        let items = fullNameInID; //logic #4 to concact with all string
        items = items.split(" ");
        const combinations = [];
        const combinationswithspace = [];
        const combinationswithReverse = [];
        const combinationswithRevSpace = [];


        for (let i = 0; i < items.length; i++) {
            for (let j = i + 1; j < items.length; j++) {
                combinations.push(items[i].toUpperCase() + items[j].toUpperCase());
                combinationswithspace.push(items[i].toUpperCase() + " " + items[j].toUpperCase());
                combinationswithReverse.push(items[j].toUpperCase() + items[i].toUpperCase());
                combinationswithRevSpace.push(items[j].toUpperCase() + " " + items[i].toUpperCase());
            }
        }


        // insert to array items 
        const mergedArray = itemsArray.concat(updatedItems, toremoveSpaceArry, combinations, combinationswithspace, combinationswithReverse, combinationswithRevSpace);
        ////console.log('Merged--->' + mergedArray);

        const arraySet1 = new Set(mergedArray);
        const allPresent1 = nameOfAcntHolder.every(value => arraySet1.has(value.toUpperCase()));
        if (!allPresent1) {
            return "Account Holder Name must be the same as full name in NRIC/Passport";
        }
        ////////console.log('final result----->' + allPresent1); // Output: true
    }

}
export const acntNameValidator = (value) => {

    if (!value) {
        return "Please enter Name on Debit Card."
    } else if (!notAllowSpclname.test(value)) {
        return "Please enter Name on Debit Card."
    } else if (value.length > 19) {
        return "Please enter Name on Debit Card."
    }

    // if (!value) {
    //     return "Please enter Name of Debit Card.";
    // }
    // else if (value.length > 19) {
    //     return "Please enter Name of Debit Card.Max 19char";
    // }
    // else if (!allowOnlyChars.test(value)) {
    //     return "Numeric Account Holder Name not acceptable."
    // }


    // else if (value) {

    //     //APR 2024 new validation rules 

    //     let fullNameInID = localStorage.getItem('CFN');
    //     fullNameInID = fullNameInID.toUpperCase();


    //     let nameOfAcntHolderVal = value;
    //     nameOfAcntHolderVal = nameOfAcntHolderVal.toUpperCase();
    //     let nameOfAcntHolder = nameOfAcntHolderVal.split(" ");

    //     const itemsArray = fullNameInID.split(" "); //logic 3 to separate all string value to array items
    //     ////console.log("itemsArray----->" + itemsArray);
    //     const updatedItems = itemsArray.map(item => item.charAt(0)); //logic #002 to get first char
    //     ////console.log(updatedItems);

    //     const toremoveSpaceArry = fullNameInID.replace(/\s/g, '') //logic #001 to merge text
    //     ////console.log("toremoveSpaceArry---->" + toremoveSpaceArry);

    //     ////console.log(toremoveSpaceArry);



    //     let items = fullNameInID; //logic #4 to concact with all string
    //     items = items.split(" ");
    //     const combinations = [];
    //     const combinationswithspace = [];
    //     const combinationswithReverse = [];
    //     const combinationswithRevSpace = [];


    //     for (let i = 0; i < items.length; i++) {
    //         for (let j = i + 1; j < items.length; j++) {
    //             combinations.push(items[i].toUpperCase() + items[j].toUpperCase());
    //             combinationswithspace.push(items[i].toUpperCase() + " " + items[j].toUpperCase());
    //             combinationswithReverse.push(items[j].toUpperCase() + items[i].toUpperCase());
    //             combinationswithRevSpace.push(items[j].toUpperCase() + " " + items[i].toUpperCase());
    //         }
    //     }


    //     // insert to array items 
    //     const mergedArray = itemsArray.concat(updatedItems, toremoveSpaceArry, combinations, combinationswithspace, combinationswithReverse, combinationswithRevSpace);
    //     ////console.log('Merged--->' + mergedArray);

    //     const arraySet1 = new Set(mergedArray);
    //     const allPresent1 = nameOfAcntHolder.every(value => arraySet1.has(value.toUpperCase()));
    //     if (!allPresent1) {
    //         return "Account Holder Name must be the same as full name in NRIC/Passport";
    //     }
    //     ////////console.log('final result----->' + allPresent1); // Output: true
    // }

}



export const cardValidator = (value) => {
    if (!value) {
        return "Please enter a valid Savings or Current Account Number"
    } else if (!ccardRegex.test(value)) {
        return "Please enter a valid Savings or Current Account Number"
    } else if (value.substring(0, 2).trim() !== "04" && value.substring(0, 2).trim() !== '14' && value.substring(0, 2).trim() !== '64') {
        return "Please enter a valid Savings or Current Account Number"
    } else if (value.length !== 11) {
        return "Please enter a valid Savings or Current Account Number"
    }

}

export const AmountValidator = (value) => {
    const amtVal = parseInt(helper.getAmtValidValue());
    if (!value) {
        return "Please enter the transfer amount."
    } else if (value < amtVal) {
        return "Minimum amount is " + helper.displayAmtNote() + " and should be in multiples of S$100.";
    } else if (value > 9999999999.99) {
        return "Please enter valid transfer amount."
    } else if (parseInt(value) % 100 !== 0) {
        return "Minimum amount is " + helper.displayAmtNote() + " and should be in multiples of S$100.";
    }
}

export const phoneValidator = (value) => !value ?
    "Phone number is required." :
    phoneRegex.test(value) || value < 8 ? "" : "Not a valid phone number.";

export const bankAcntValidator = (value) => {
    if (!value) {
        return "Please input a valid Credit Card Number"
    } else if (value.length !== 16) {
        return "Please enter a vaild NRIC/Passport Number"
    } else if (value.length > 20) {
        return "Please enter a vaild NRIC/Passport Number"
    }
}

export const cradNAccountNumber = (value) => {
    //before Pre login FT changes Apr 2023.docx
    // if (!value) {
    //     return "Please enter credit card/line of credit/current or savings account number of nominated bank. "
    // } else if (value.length > 20) {
    //     return "Please enter credit card/line of credit/current or savings account number of nominated bank. "
    // }

    //Pre login FT changes Apr 2023.docx
    const sValue = value.replace(/[^A-Za-z0-9 ]/g, "");
    const cardValue = sValue.split(" ").join("");

    if (!value) {
        return "Please enter credit card/line of credit/current or savings account number of nominated bank. "
    }
    else if (value.length > 20) {
        return "Please enter credit card/line of credit/current or savings account number of nominated bank. "
    }
    else if ((cardValue.substring(0, 2) === '14' || cardValue.substring(0, 2) === '04') && cardValue.length === 11) {
        return "Please provide a non-Maybank Account number"
    }
    else if (cardValue.substring(0, 4) === '0413' && cardValue.length === 11) {
        return "Please provide a non-Maybank Account number"
    }
    else if (cardValue.substring(0, 6) === '518834' && cardValue.length > 6) { // APR 2024
        return "Please provide a non-Maybank Account number"
    }
    else if (cardValue.substring(0, 3) === '413' && cardValue.length === 10) {
        return "Please provide a non-Maybank Account number"
    }
    // else if(cardValue.substring(0,6) === '518834' || cardValue.substring(0,6) === '554704'
    // || cardValue.substring(0,6) === '496643' || cardValue.substring(0,6) === '401636'  
    // || cardValue.substring(0,6) === '469619') {
    //     return "Please provide a non-Maybank Account number"
    // }
    else if (helper.isMayBankCardBINList(cardValue.substring(0, 8))) {
        return "Please provide a non-Maybank Account number"
    }
}

export const cvcValidator = (value) => !value ?
    "CVC code is required," :
    cvcRegex.test(value) || value.length !== 3 ? "" : "Not a valid CVC code format.";
export const guestsValidator = (value) => !value ?
    "Number of items is required" :
    value < 5 ? "" : "Maximum 5 items";

export const requiredValidator = (value) => value ? "" : "Error: This field is required.";
export const passwordValidator = (value) => value && value.length > 8 ? '' : 'Password must be at least 8 symbols.';
export const addressValidator = (value) => value ? "" : "Address is required.";
export const tovalidateExpdate = (value) => {
    let localExpTime = window.localStorage.getItem('expid');
    if (value > parseInt(localExpTime) + 9) {
        return false

    } else {
        return true
        //nothing
    }


}